import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

import { GradeColor, gradeColor, gradeLabel } from "../asset-review/grade-colors";

@Component({
  selector: "app-store-grade-card",
  templateUrl: "./store-grade-card.component.html",
  styleUrls: ["./store-grade-card.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class StoreGradeCardComponent {
  @Input() grade: string;
  @Input() isFullScreen: boolean = false;
  @Input() isNewPage: boolean = false;

  /**
   * Fill and contrast text colour for the badge. Comes from the shared palette so this card,
   * the subscore badges, the history rows and the full breakdown never disagree on a colour.
   * A missing or unrecognised grade falls back to the neutral N/A treatment.
   */
  get badge(): GradeColor {
    return gradeColor(this.grade);
  }

  get label(): string {
    return gradeLabel(this.grade);
  }
}
